import React from "react";
import { Col, Row } from "react-bootstrap";
import DashboardHeader from "../../../../components/Common/DashboardHeader";
import { Placeholder } from "../../../../components/Common/LoadingPlaceholder";
import "./PerformanceWorkspace.css";

export const PerformanceWorkspace = ({
    eyebrow,
    title,
    subtitle,
    highlight,
    summaryCards = [],
    children
}) => {
    return (
        <div className="performance-workspace">
            <DashboardHeader
                eyebrow={eyebrow}
                title={title}
                subtitle={subtitle}
                metrics={highlight ? [{
                    key: highlight.label,
                    label: highlight.label,
                    value: highlight.value,
                    tone: "info"
                }] : []}
            />

            {summaryCards.length > 0 && (
                <Row className="g-3 mb-4">
                    {summaryCards.map((card) => (
                        <Col xl={3} md={6} key={card.label}>
                            <PerformanceSummaryCard {...card} />
                        </Col>
                    ))}
                </Row>
            )}

            {children}
        </div>
    );
};

/**
 * Cartão de resumo do Desempenho.
 *
 * @param {boolean=} props.loading número ainda sendo calculado: mostra o esqueleto com brilho, como
 *        a Visão do Negócio, em vez de um valor provisório que pareceria resultado
 */
export const PerformanceSummaryCard = ({ label, value, detail, icon, tone = "slate", loading = false }) => {
    return (
        <div className={`performance-workspace__summary-card performance-workspace__summary-card--${tone}`}>
            <div className="performance-workspace__summary-header">
                <span>{label}</span>
                {icon && (
                    <div className="performance-workspace__summary-icon">
                        <i className={`fas ${icon}`}></i>
                    </div>
                )}
            </div>
            {loading ? (
                // O esqueleto é decorativo; o texto oculto avisa o leitor de tela que o valor está chegando.
                <strong className="performance-workspace__summary-loading" aria-busy="true">
                    <span className="visually-hidden">Carregando</span>
                    <Placeholder width="55%" height="1.6rem" />
                </strong>
            ) : (
                <strong>{value}</strong>
            )}
            {detail && <p>{detail}</p>}
        </div>
    );
};

export const PerformancePanel = ({ title, subtitle, action, children, className = "" }) => {
    return (
        <section className={`performance-workspace__panel ${className}`.trim()}>
            {(title || subtitle || action) && (
                <div className="performance-workspace__panel-header">
                    <div>
                        {title && <h5>{title}</h5>}
                        {subtitle && <p>{subtitle}</p>}
                    </div>
                    {action && <div className="performance-workspace__panel-action">{action}</div>}
                </div>
            )}

            {children}
        </section>
    );
};
